<template>
    <div :class="`multi-date-picker-hh ${alignLeftStart ? 'multi-date-picker-left' : ''}`" ref="multiDatePicker">
        <input class="form form-control pe-4" v-show="false" :value="result" ref="multiDatePickerInput" />
        <span class="multi-date-picker-clear" v-show="false" @click="clearResult()" v-tooltip="{ title: `Clear` }">
            <i class="fas fa-times"></i>
        </span>
        <div class="multi-calendar-wrapper-hh" ref="_calendarElementWrapper">
            <div class="multi-calendar-element"></div>
            <div class="multi-calendar-element"></div>
            <div class="multi-calendar-element"></div>
        </div>
    </div>
</template>

<style lang="scss" src="./MultiDatePickerHH.scss"></style>
<script lang="ts" src="./MultiDatePickerHH"></script>
